module.exports = __webpack_public_path__ + "img/good-vibes-w-elixer_300x92.04b7044e.png";